module.exports = __webpack_public_path__ + "static/media/ic_video_white.f74d0e12.svg";